import React from "react";
import PageLayout from "../../components/PageLayout";
import OBHavingTroubleCard from "../onboarding/_components/OBHavingTroubleCard";
import FinanceMainWrapper from "./components/FinanceMainWrapper";
import "./style/finance.css";

function BookingsMain() {
  return (
    <PageLayout>
      <section className="d-flex flex-row align-items-start gap-3 product-listing-main-wrapper-section">
        <FinanceMainWrapper />
        {/* <OBHavingTroubleCard /> */}
      </section>
    </PageLayout>
  );
}

export default BookingsMain;
